export const Color = {
  darkBlue: "#0e182a",
  dimBlue: "#152238",
  lightBlue: "#81a7ff",
  blueLite: "#426d9f6b",
  orange: "#f44b24",
  orangeLite: "#f44b2469",
  yellow: "#f0bd27",
  yellowLite: "#f0bd273d",
  pointsColor: "#b8e986",
  commentsColor: "#50e3c2",
  white: "#fff",
  black: "#000",
  gray: "#9b9b9b",
  transparent: "transparent",
};

export const Font = {
  logo: "Poppins, sans-serif",
  news: "Quicksand, sans-serif",
};
